import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { SapC4CResourceDataset } from 'app/model/dataset/sapc4c-resource.dataset';

import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { Constants } from 'app/shared/shared-constants';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapc4c.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(SapC4CResourceDataset) }
})
export class SapC4CSink extends CopySink {
    public static readonly MODEL: IModel;
    public static readonly WRITE_BEHAVIOR: IAttribute;
    public static readonly WRITE_BATCH_SIZE: IAttribute;
    public static readonly HTTP_REQUEST_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = writeBehaviorOptionValues.insert;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: stringResources.ModelName_WriteBatchSize
    })
    public writeBatchSize?: number = 10;

    @Metamodel.attribute({
        templatable: true,
        association: 'HTTP_REQUEST_TIMEOUT',
        display: `${stringResources.ModelName_Request_Timeout}`,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public httpRequestTimeout?: string = '00:05:00';
}
